import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

const timeSlots = ["9am-11am", "11am-1pm", "1pm-3pm", "3pm-5pm"];

const EditProviderAvailabilityModal = ({
  isOpen,
  onClose,
  providerAvailabilityData,
  handleEditAvailability,
  editAvailabilityLoading,
}) => {
  const [selectedSlots, setSelectedSlots] = useState([]);

  // Set selected slots when modal opens
  useEffect(() => {
    if (isOpen && providerAvailabilityData?.time_slots) {
      const preselectedSlots = providerAvailabilityData.time_slots.map(
        (slot) => slot.time
      );
      setSelectedSlots(preselectedSlots);
    }
  }, [isOpen, providerAvailabilityData]);

  const toggleSlotSelection = (slot) => {
    setSelectedSlots((prev) =>
      prev.includes(slot) ? prev.filter((s) => s !== slot) : [...prev, slot]
    );
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => {
          onClose();
          //   formik.resetForm();
        }}
        className="relative z-50"
      >
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg sm:max-w-md md:max-w-lg">
              <div className="bg-[#21140E0F] px-4 pb-6 pt-3 sm:px-6">
                <div className="flex justify-between items-center mb-2">
                  <DialogTitle className="text-lg sm:text-xl font-bold text-[#284184]">
                    Select Time for {providerAvailabilityData?.date}
                  </DialogTitle>
                  <button
                    onClick={() => {
                      onClose();
                      //   formik.resetForm();
                    }}
                    className="text-[#1C2024] hover:bg-gray-100 p-1.5 rounded-full transition-colors"
                  >
                    <span className="text-2xl sm:text-4xl leading-none">
                      &times;
                    </span>
                  </button>
                </div>
                <div>
                  <div className="grid grid-cols-2 gap-3">
                    {timeSlots.map((slot) => (
                      <button
                        key={slot}
                        onClick={() => toggleSlotSelection(slot)}
                        className={`px-4 py-2 rounded-xl text-lg border transition ${
                          selectedSlots.includes(slot)
                            ? "bg-[#E0A256] text-[#000000]"
                            : "bg-[ffffff] text-[#000000] border-[#d5d6db]"
                        }`}
                      >
                        {slot}
                      </button>
                    ))}
                  </div>
                  {/* Add Button */}
                  <button
                    className="w-full bg-[#284184] text-white font-semibold py-2 rounded-xl mt-6"
                    onClick={() =>
                      handleEditAvailability(selectedSlots.join(","))
                    }
                  >
                    {editAvailabilityLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default EditProviderAvailabilityModal;
